export default "__VITE_ASSET__jIKOsO_A__"